// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"328":"admin","423":"scoring","609":"team","996":"info"}[chunkId] + "." + {"328":"412818f1","423":"f833325e","609":"8e326b4a","996":"e09b7043"}[chunkId] + ".css";
};